import React from "react";

// Founder photo card. Drop /app/frontend/public/gustavo-gonzalez-fiscalbond.jpg
// and the image will be picked up automatically. While the file is missing,
// a styled "GG" initial avatar is shown as fallback.
export const FounderCard = () => {
  const [errored, setErrored] = React.useState(false);
  return (
    <div
      data-testid="founder-card"
      className="mt-10 bg-[#0B1B33] border border-white/10 rounded-3xl p-6 md:p-8 flex flex-col sm:flex-row items-center sm:items-start gap-6 shadow-lg shadow-black/20"
    >
      <div className="relative shrink-0">
        <div className="w-[120px] h-[120px] rounded-full p-[3px] bg-[#3B82F6]">
          <div className="w-full h-full rounded-full overflow-hidden bg-gradient-to-br from-[#1E3A5F] to-[#0A1628] flex items-center justify-center">
            {!errored ? (
              <img
                src="/gustavo-gonzalez-fiscalbond.jpg"
                alt="Gustavo González — Fundador FiscalBond"
                onError={() => setErrored(true)}
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-3xl font-bold text-white tracking-wider" style={{ fontFamily: "Poppins" }}>
                GG
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="text-center sm:text-left">
        <h3 className="text-[18px] font-bold text-white leading-tight" style={{ fontFamily: "Poppins" }}>
          Gustavo González
        </h3>
        <p className="text-[14px] text-slate-300 mt-1">
          Fundador y Director · FiscalBond
        </p>
        <p className="mt-3 text-sm md:text-[15px] text-slate-300 leading-relaxed max-w-xl">
          Importador registrado de vino y espirituosos con experiencia directa
          en operaciones bajo régimen suspensivo. Titular del RETEF concedido
          por la AEAT.
        </p>
        <p className="mt-3 text-[12px] text-[#FF6B00] font-mono tracking-wide">
          REDEF Nº 004VBSG6OC001684166
        </p>
      </div>
    </div>
  );
};

export default FounderCard;
